import React from "react";
import styles from "../styles/Header.module.css";

const AboutPage = () => (
  <div className={styles.page}>
    <section className={styles.about}>
      <div className={styles.sectionWrap}>
        <h2 className={styles.sectionHeading}>About</h2>
        <div className={styles.aboutContent}>
          <div className={styles.aboutText}>
            <p>
              I'm a full-stack engineer based in Nigeria, five years in.
              Most of that time has been in travel tech — I built and
              maintain GetThere, a live tour aggregation platform used
              by operators and travelers daily, at my current company.
            </p>
            <p>
              Outside of work I ship things that interest me: TravelBook Lite
              came from watching sub-agents at small travel agencies struggle
              with manual pricing and bank reconciliation. I also publish
              open-source tooling for the travel dev space. I write code
              other engineers can read, and I care about the decisions behind
              the code as much as the code itself.
            </p>
            <p>Currently open to full-time roles.</p>
            <div className={styles.aboutStack}>
              {[
                "React",
                "Node.js",
                "TypeScript",
                "PostgreSQL",
                "MongoDB",
                "Express.js",
                "Next.js",
                "Paystack",
              ].map((s) => (
                <span key={s}>{s}</span>
              ))}
            </div>
            <a
              href="https://docs.google.com/document/d/1p4GNalpikG7dEBD7rmTR__lS41QY5RKhIJvKkOpirmo/edit?usp=sharing"
              target="_blank"
              rel="noopener noreferrer"
              className={styles.resumeLink}
            >
              View Resume ↗
            </a>
          </div>
        </div>
      </div>
    </section>
  </div>
);

export default AboutPage;
